import {GetBannersRequest} from 'domain/usecases';
import {makeGetBanners} from 'main/factories/usecases';

export const getBanners = async (params: GetBannersRequest) => makeGetBanners().post(params);
